import React from 'react';
import clsx from 'clsx';

import { useTranslation } from 'react-i18next';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import reactHtmlParser from 'react-html-parser';

import { useStylesChildren } from '../styles';
import Card from '../../Card';
import TextField from '../../TextField';
import { generateInputParamsAttributesPdf } from '../../InputParameters/constants';
import FormChip from '../../Chips/FormChip';

const DesignParameters = props => {
	const { t } = useTranslation();
	const classes = useStylesChildren();
	const { values, touched, errors, handleChange, handleBlur } = props.formikProps;

	return (
		<Card id="DesignParameters__expansion_panel" title={t('components.inputs.designParameters.title')}>
			<Grid container direction="row" className={clsx(classes.accordionContent, classes.focusableTextField)}>
				<Grid item xs>
					<FormChip
						title={t('components.inputs.designParameters.qualification')}
						label={t('components.inputs.designParameters.automotiveDesignOnly')}
						valueName={'automotiveDesign'}
						value={values.automotiveDesign}
						handleChange={handleChange}
					/>
				</Grid>
				<Grid item xs>
					<TextField
						id="DesignParameters__ambientTemperature_text_field"
						label={reactHtmlParser(
							generateInputParamsAttributesPdf('').find(item => item.value === 'ambientTemperature').formattedLabel
						)}
						name="ambientTemperature"
						InputProps={{
							endAdornment: <InputAdornment position="end">&deg;C</InputAdornment>,
							classes: {
								focused: classes.focusableTextField
							}
						}}
						maxLength={10}
						onChange={handleChange}
						onBlur={handleBlur}
						value={values.ambientTemperature}
						helperText={touched.ambientTemperature && errors.ambientTemperature ? errors.ambientTemperature : '\u00a0'}
						error={touched.ambientTemperature && errors.ambientTemperature}
					/>
				</Grid>
			</Grid>
		</Card>
	);
};

export default DesignParameters;
